import { Injectable } from '@angular/core';
import { ApiService, UserService } from '../../index';
@Injectable()
export class BaocaochatluonggprsService {
  APIURL = "api/ExcuteOracle";
  constructor(private apiService: ApiService, private userService: UserService) { }
  baocaochatluong(danhmucid, thoigian) {
    var param = {
      "config": '{"namesql":"PKG_BAOCAOCHATLUONG_GPRS.P_BAOCAOCHATLUONG"}',
      "para": '{"v_date":"' + thoigian + '","v_code":"' + danhmucid + '"}'
    };
    return this.apiService.Excute(this.APIURL, param);
  }
  exportExcelChatLuongHeThong(data, filename, title, header, sheetname) {

    let cols = [];
    cols.push({ "name": "1", "label": "STT", "horizontalalignment": "center" })
    let columns = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "tendanhmuc", "label": "Đơn vị", "horizontalalignment": "left" },
      { "name": "docthanhcong", "label": "Đọc thành công", "horizontalalignment": "center" },
      { "name": "khongdulieu", "label": "Chưa có dữ liệu", "horizontalalignment": "center" },
      { "name": "tong", "label": "Tổng điểm đo", "horizontalalignment": "center" },
      { "name": "tyle", "label": "Tỷ lệ đọc thành công", "horizontalalignment": "center" },
    ];
    var param = {
      config: "",
      para: "",
      title: title,
      header: header,
      filename: "",
      sheets: sheetname,
      columns: columns,
      data: JSON.stringify(data)
    };
    return this.apiService.downloadFile("api/ExportExcel", param, filename + ".xlsx");
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/bao-cao/bao-cao-chat-luong/baocaochatluonggprs.service.ts